import React, { useEffect, useState } from 'react'
import { Button, Form, message, Radio, Space } from 'antd';
import { labels } from './efectos_emt_catalog';
import { checkEncuesta, EncuestaLoading, ThanksMessage } from '../utils';
import { sendDataBody } from '../../resources';

export default function EfectosEmtEncuesta({ idpaciente, idmedico, token, visita, session, protocolo = 'default' }) {


    const [encuestaNotExists, setEncuestaNotExists] = useState(null)
    const [checking, setChecking] = useState(true)
    const [pacienteData, setPacienteData] = useState({})
    const [medicoData, setMedicoData] = useState({})


    useEffect(() => {
        init()
    }, [])

    function init() {
        checkEncuesta(idpaciente, visita, 'efectos_emt', session, protocolo, setPacienteData, idmedico, setMedicoData, setEncuestaNotExists, setChecking)
    }

    const onFinish = (values) => {
        console.log('Received values of form:', values);
        const body = {
            usuario: idpaciente,
            medico: idmedico,
            efectos_emt: Object.values(values),
            tipo: 'efectos_emt',
            uuid: token,
            visita: visita,
            sesion: session,
            protocolo: protocolo
        }
        sendDataBody('encuestas/add', body).then((rs) => {
            console.log('add enc resp', rs)
            message.success(rs.message)
        }).then(() => init())
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    if (checking) return <EncuestaLoading />

    if (!encuestaNotExists) return <ThanksMessage />

    return (
        <div className='parentContainer' style={{ height: '100vh' }}>
            <div className='formContainer'>


                <p>Fecha: {new Date().toLocaleDateString()}</p>
                <p>Hora: {new Date().toLocaleTimeString()}</p>
                <p>Paciente: {pacienteData.name}</p>
                <p>Medico: {medicoData.name}</p>

                <h3>Lista de Verificación de Efectos Secundarios de la EMT </h3>
                <p >A continuación, encontrará una lista de posibles efectos secundarios que pueden presentarse durante o después de las sesiones de Estimulación Magnética Transcraneal (EMT).
                    Por favor, lea cuidadosamente cada ítem y marque la opción que mejor describa su experiencia durante o después de la sesión. Esta información nos ayudará a monitorear su seguridad y bienestar Instrucciones para cada ítem: </p>

                <p style={{ fontWeight: 'bold' }}> Marque 'Sí' si ha experimentado el efecto descrito</p>
                <p style={{ fontWeight: 'bold' }}> Marque 'No' si no lo ha experimentado </p>
                <p style={{ fontWeight: 'bold' }}> Marque 'No estoy seguro(a)' si no puede determinarlo con claridad. </p>
                <br />

                <Form
                    layout='vertical'
                    name="efectos_form"
                    // labelCol={{ span: 8 }}
                    // wrapperCol={{ span: 16 }}
                    initialValues={{}}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >

                    {
                        labels.map((label, index) => (
                            <Form.Item
                                label={label}
                                name={index}
                                rules={[{ required: true, message: 'Selecciona una respuesta' }]}
                            >
                                <Radio.Group>
                                    <Space direction="vertical">
                                        {
                                            ['No', 'No estoy seguro(a)','Sí'].map((rs, i) => <Radio value={i}>{rs}</Radio>)
                                        }
                                    </Space>
                                </Radio.Group>
                            </Form.Item>
                        ))
                    }

                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Guardar
                        </Button>
                    </Form.Item>
                </Form>

                <br />
            </div>
        </div>
    )
}
